<div class="logo">
  <img *ngIf="!isSmartphone" [src]="'/assets/images/logo.png'" [class.hidden]="isScrolled" alt="Logo original" class="logo-default">
  <img *ngIf="!isSmartphone" [src]="'/assets/images/icon_athena.png'" [class.hidden]="!isScrolled" alt="Logo scrolled" class="logo-scrolled"><div *ngIf="!isSmartphone" [class.hidden]="!isScrolled">ATHENA TECHNOLOGIES</div>
  <img *ngIf="isSmartphone" [src]="'/assets/images/icon_athena.png'"  alt="Logo scrolled" class="logo-scrolled">
</div>

<header [class.scrolled]="isScrolled" class="main-header">
  <nav class="navbar navbar-expand-lg fixed-top">
    <div class="container">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="#home" [class.active]="activeSection === 'home'" (click)="scrollToSection('home', $event)">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#solutions" [class.active]="activeSection === 'solutions'" (click)="scrollToSection('solutions', $event)">Solutions</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#workflow" [class.active]="activeSection === 'workflow'" (click)="scrollToSection('workflow', $event)">Processus</a>
          </li>
<!--          <li class="nav-item">-->
<!--            <a class="nav-link" href="#team" [class.active]="activeSection === 'team'" (click)="scrollToSection('team', $event)">Team</a>-->
<!--          </li>-->
          <li class="nav-item">
            <a class="nav-link" href="#contact" [class.active]="activeSection === 'contact'" (click)="scrollToSection('contact', $event)">Contact</a>
          </li>
        <!--  <li class="nav-item" *ngIf="isLoggedIn">
            <a class="nav-link" href="#demo" [class.active]="activeSection === 'demo'" (click)="scrollToSection('demo', $event)">Démo</a>
          </li>
          <li class="nav-item dropdown" (mouseenter)="openDropdown()" (mouseleave)="closeDropdown()">
            <a class="nav-link client-dropdown-toggle">
              Espace client
            </a>
            <ul class="dropdown-menu" [class.show]="dropdownOpen">
              <li *ngIf="!isLoggedIn"><div class="dropdown-item" href="#home" (click)="openLoginDialog()">Se connecter</div></li>
              <li *ngIf="isLoggedIn"><div class="dropdown-item" (click)="logout()">Se déconnecter</div></li>
            </ul>
          </li>-->
        </ul>
      </div>
    </div>
  </nav>
</header>
